
import Vue from 'vue';
import LiveStockRegisterOverview from '@/components/livestock-register/LiveStockRegister.vue';

export default Vue.extend({
  name: 'LiveStockRegister',
  components: { LiveStockRegisterOverview },
});
